import React from 'react';
import { Trans } from 'react-i18next';

import { Banner } from 'components/banner';

import { TypographyVariants } from 'constants/typography-variants';
import { Typography } from 'components/typography';

import { useStyles } from './styles';

export const TipBanner = () => {
    const { tipBannerText } = useStyles();

    return (
        <Banner>
            <Typography variant={TypographyVariants.h3} className={tipBannerText}>
                <Trans i18nKey={'pre-paywall-tip-banner'} components={[<span></span>]} />
            </Typography>
        </Banner>
    );
};
